<template>
  <div>
    <v-menu
      v-model="showRequestDatePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          ref="date"
          :rules="[rules.required]"
          v-model="formattedDate"
          class="pr-2"
          :label="$t('Fecha de finalización')"
          readonly
          mask="date"
          v-on="on"
          box
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="formData.fecha_fin"
        @input="showRequestDatePicker = false"
        locale="es"
        first-day-of-week="1"
        :reactive="true"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
const moment = require('moment');
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          fecha_fin: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      showRequestDatePicker: false,
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formattedDate: {
      get() {
        return this.formData.fecha_fin ? moment(this.formData.fecha_fin).format('DD/MM/YYYY') : '';
      },
      set(value) {
        this.$emit('input', this.formData);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
